import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import PieChart, {
    Legend,
    Series,
    Tooltip,
    Format,
    Label,
    Connector,
    Export,
    Margin,

} from 'devextreme-react/pie-chart';
import { getPalette } from 'devextreme/viz/palette';
import { FadingBalls } from 'react-cssfx-loading/lib';


import Grid from '@mui/material/Grid';

export default function WasteStreamDonuts(props) {
    const classes = useStyles();

    const paletteCollection = ['Ocean', 'Soft Pastel', 'Harmony Light', 'Pastel', 'Bright', 'Soft', 'Ocean', 'Office', 'Vintage', 'Violet', 'Carmine', 'Dark Moon', 'Soft Blue', 'Dark Violet', 'Green Mist'];
    const palette = paletteCollection[0];

    return (
    <Grid key="Charts" container className={classes.gridClass}  spacing={2}>
            {props.data.map(x => {
                return (
                    <Grid key={x.wasteStreamDescription} item className={classes.donutChartGrid} xs={12} md={6} lg={4}>  
                        <div className={classes.pieDiv}>
                            <PieChart dataSource={x.pieData}
                                className={classes.donutChart} 
                                type="doughnut"
                                title={x.wasteStreamDescription}
                                format="decimal"
                                palette="Ocean"
                                paletteExtensionMode="blend"
                                resolveLabelOverlapping={'shift'}
                                >
                                <Legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top" />
                                    
                                <Format type="fixedPoint" decimalSeparator="," precision={2} />
                                <Margin top={20} bottom={20}  />
                                <Series argumentField="city" palette="Ocean" >
                                    <Label visible={true} format="fixedPoint" customizeText={customizeLabel}>
                                        <Connector visible={true} />
                                    </Label>
                                </Series>
                                <Export enabled={true}/>
                         
                                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                                    <Format type="fixedPoint" decimalSeparator="," precision={2} />
                                </Tooltip>
                            </PieChart>
                            <div className="palette-container flex-block">
                                {getPalette(palette).simpleSet.map((color) => (
                                <div
                                    className="palette-item"
                                    style={{ backgroundColor: color }}
                                    key={color}
                                />
                                ))}
                            </div>
                            {props.isLoading ?  

                                <div className={classes.loadingNewData}>
                                    <div className={classes.loadingContainer}>
                                        <div className={classes.loadingCharts}>{"Grafiek laden"}</div>
                                        <FadingBalls color="#1F8FA5" width="15px" height="15px"></FadingBalls>
                                    </div>
                                </div> 
                                    : <React.Fragment></React.Fragment>
                            }    
                                    
                        </div>   
                        
                    </Grid>
                )})}
        </Grid>
    )
}
const tonnageFormatter = new Intl.NumberFormat(
    'nl-BE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  );
function customizeLabel(args) {
    if (args.originalValue === 0) {
        const valueText = tonnageFormatter.format(args.originalValue);
        let html = `<div class="tonnage" style="font-size: 70%"> ${valueText} TON</div>`;
        return html;
    }else{
        const valueText = tonnageFormatter.format(args.originalValue);
        let html = `<div class="tonnage"> ${valueText} TON</div>`;
        return html;
    }
  }

  const customizeTooltip =(arg) => {
    const valueText = tonnageFormatter.format(arg.originalValue);
    const percentage = tonnageFormatter.format((arg.percent * 100).toFixed(2));
    let tooltipHTML = '';
    tooltipHTML += '<div>'+ arg.argument + '</div>';
    tooltipHTML += '<div>'+ valueText + ' TON - ' + percentage+ '%</div>'
    return {html: tooltipHTML};
  }
const useStyles = makeStyles(() => ({
    container: {

        marginTop: '25px',
        display: 'flex',
    },
    gridClass: {
        marginTop: '0px !important',
        marginBottom: '16px !important',
    },
    pieDiv: {
        position: 'relative',
    },
    donutChart: {

        background: 'white',
    },
    loadingNewData: {
        height: "100%",
        width: "100%",
        background: "white",
        position: "absolute",
        top: "0",
        opacity: '50%'
    },
    loadingContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
}));